module.exports = __webpack_public_path__ + "static/media/BasisGrotesqueProWinnowBeta12-Regular.3fe25936.woff";